import ApiServiceAssesments from "../apiServiceAssesments.js";

const querystring = require('querystring')
var AssociateDataModelService = {

    formBuilder: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "formBuilder"
            $options.method = "get"

            if ($data) {
                $options.url = "formBuilder?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceAssesments.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });
    },
    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "formModel"
            $options.method = "get"

            if ($data) {
                $options.url = "formModel?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceAssesments.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "formModel/" + $data
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiServiceAssesments.request($options)
                .then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "formModel/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiServiceAssesments.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "formModel2" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiServiceAssesments.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "formModel2";
            $options.method = "post"
            console.log($options)
            ApiServiceAssesments.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default AssociateDataModelService;